import React from 'react'
import AccountInfo from './AccountInfo'
import CartButton from './CartButton'
import SearchBox from './SearchBox'
import DrawerTipologia from './DrawerTipologia'
import { useSelector } from 'react-redux'
import { AppBar, Toolbar, Box, useMediaQuery, useTheme } from '@mui/material'

const styles = {
    toolBar: {
        backgroundColor: 'white',
        color: 'black',
        paddingLeft: 6,
        paddingRight: 6,
    },
    toolBarMobile: {
        backgroundColor: 'white',
        color: 'black',
        paddingLeft: 6,
        paddingRight: 6,
        display: "flex",
        flexDirection: "column"
    },
    tabWrapper: {
        fontSize: '1.1rem',
        fontWeight: 'bold',
        color: 'black',
    },
    navBarMargin: {
        marginRight: '1rem'
    },
    root: {
        flexGrow: 0.3, '&& .Mui-selected': { fontSize: '13px' }
    }
}

export default function Navbar() {
    const { isLoggedIn, roles } = useSelector(state => state.account)
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))
    return (
        <>
            {isLoggedIn && (roles && !roles.includes("Vendedor") && !roles.includes("Admin Ventas")) ?
                <AppBar position='static'>
                    <Toolbar style={mobile ? styles.toolBarMobile : styles.toolBar}>
                        <DrawerTipologia style={styles.navBarMargin} />
                        <Box flexGrow={1.5} />
                        <SearchBox style={styles.navBarMargin} />
                        <Box flexGrow={0.8} />
                        {mobile ? <Box flexGrow={0.8} sx={{ display: "flex", alignContent: "center" }}>
                            <CartButton />
                            <AccountInfo />
                        </Box> :
                            <>
                                <CartButton />
                                <AccountInfo />
                            </>
                        }
                    </Toolbar>
                </AppBar>
                : null
            }
        </>
    )
}